import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { DateTime } from "luxon";

import { formatMoney } from "../../DashboardView/dashboardHelpers";

const LABEL_SX = { fontSize: "0.65rem", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "text.secondary" };
const VALUE_SX = { fontWeight: 700, fontSize: "0.9rem", lineHeight: 1.3 };

// The court booking being moved, and what paid for it: two columns on a wide screen,
// stacked on a phone.
function CourtRescheduleBanner({ reschedule, currency, sx }) {
  const info = reschedule.info;
  const from = info?.from;
  const when = from ? [DateTime.fromISO(from.date).toFormat("ccc d LLL"), from.time, `${from.duration} min`].join(" · ") : null;
  const where = from ? [from.facilityName, from.locationName].filter(Boolean).join(" · ") : null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "primary.main",
        bgcolor: (t) => alpha(t.palette.primary.main, 0.05),
        position: "relative",
        ...sx
      }}
    >
      <Button
        size="small"
        onClick={reschedule.cancel}
        sx={{ position: "absolute", top: "0.375rem", right: "0.375rem", textTransform: "none", minWidth: 0, px: 1 }}
      >
        Keep it
      </Button>

      <Box
        sx={{
          minWidth: 0,
          pr: { xs: 0, sm: "4.5rem" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          columnGap: 2.5,
          rowGap: 1.25
        }}
      >
        <Box sx={{ minWidth: 0, pr: { xs: "4.5rem", sm: 0 } }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <EventRepeatIcon sx={{ color: "primary.main", fontSize: "0.95rem" }} />
            <Typography sx={LABEL_SX}>Current booking</Typography>
          </Box>
          <Typography sx={VALUE_SX}>{when || "Loading…"}</Typography>
          {where && (
            <Typography variant="caption" color="text.secondary" component="div" noWrap>
              {where}
            </Typography>
          )}
        </Box>

        {info && (
          <Box
            sx={{
              minWidth: 0,
              pl: { xs: 0, sm: 2.5 },
              pt: { xs: 1.25, sm: 0 },
              borderStyle: "solid",
              borderWidth: 0,
              borderTopWidth: { xs: 1, sm: 0 },
              borderLeftWidth: { xs: 0, sm: 1 },
              borderColor: (t) => alpha(t.palette.primary.main, 0.25)
            }}
          >
            <Typography sx={LABEL_SX}>Paid</Typography>
            <Typography sx={VALUE_SX}>{formatMoney(info.creditAmount, currency)}</Typography>
            <Typography variant="caption" component="div" color="text.secondary">
              Moves with you — only times at this price are shown.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default CourtRescheduleBanner;
